// import AddressFinder from "../components/AddressFinder";
import FormHeader from '../components/FormHeader';
import PrimaryButton from '../components/Submit';

type IProps = {
  onNext: () => void;
  currentIndex: number;
  totalSteps: number;
};

function AddressDetails(props: IProps) {
  return (
    <div className="form-container">
      <FormHeader title="Address Details" />
      <form action="#" method="POST" onSubmit={(e) => e.preventDefault()}>
        {/* <AddressFinder /> */}

        <PrimaryButton type="button" onClick={props.onNext} loading={false}>
          Next
        </PrimaryButton>
      </form>
    </div>
  );
}

export default AddressDetails;
